import React from "react";
import { Row, Col } from "antd";
import I18n from "../../../i18n";
import { Metrics } from "../../../theme/";
import { DataVisualizeKeys } from "../../../theme/Colors";
import { VisualTotalInfomation } from "../individual_user/TotalInformation";

export default ({style, data = {male:0,female:0}, visualColorKey = DataVisualizeKeys.Primary, isVertical = false})=>{
	const colProps = isVertical ? { xs:24 } : { xs:24, md:12 };
	const colStyle = {marginBottom:Metrics.button.bigSpaceMargin};
	return (<Row style={style} gutter={Metrics.button.bigSpaceMargin}>
		<Col style={colStyle} {...colProps} >
			<VisualTotalInfomation 
				style={{height:130, padding:0, margin:0}}
				total={data.male + data.female}
				description={I18n.t("total_user")} 
				visualColorKey={visualColorKey} 
			/>
		</Col>
		<Col style={colStyle} {...colProps} >
			<Row gutter={Metrics.button.bigSpaceMargin}>
				<Col style={colStyle}>
					<VisualTotalInfomation 
						style={{height:55, padding:0, margin:0, marginBottom:Metrics.button.bigSpaceMargin}}
						total={data.female}
						description={I18n.t("female")} 
						visualColorKey={visualColorKey} 
					/>
				</Col>
				<Col>
					<VisualTotalInfomation 
						style={{height:55, padding:0, margin:0}}
						total={data.male}
						description={I18n.t("male")} 
						visualColorKey={visualColorKey} 
					/>
				</Col>
			</Row>
		</Col>
	</Row>);};


// WEBPACK FOOTER //
// ./src/components/report/stress/GenderSummaryBox.js